import * as yup from "yup";
import DATA_MODEL_TABLE from "../utils/constants/dataModelTable";
import { format, parseISO, isBefore, isValid } from "date-fns";
import { ACTION_LOG_ACTION_TYPE } from "../constants";

export const actionLogValidationSchema = () =>
  yup.object({
    actionDate: yup.date().typeError("Enter action date").required("Enter correct action date").nullable(),
    actionTime: yup
      .string()
      .typeError("Enter action Time")
      .required("Enter correct action Time")
      .test("maxtimeValidation", "Time should not be after maximal time", (value, obj) => {
        if (!value) {
          return true;
        }

        let actionDateObj = obj?.parent?.actionDate;
        if (!actionDateObj) {
          return true;
        }

        if (typeof actionDateObj === "string") {
          actionDateObj = new Date(actionDateObj);
        }

        if (!isValid(actionDateObj as Date)) {
          return true;
        }

        const valueWithDate = parseISO(`${ format(actionDateObj, "yyyy-MM-dd") }T${ value }`);
        if (!isValid(valueWithDate)) {
          return false;
        }

        return isBefore(valueWithDate, new Date());
      }),
    action: yup.string()
      .typeError("Enter action type")
      .required("Enter action type"),
    externalDocument: yup
      .array(
        yup.object({
          link: yup.string().typeError("Enter valid URL"),
          name: yup.string().typeError("Enter Description")
        })
      )
      .nullable(),
    ecrNumber: yup.string().typeError("Enter ECR number").nullable(),
    description: yup.string().typeError("Enter description").required("Enter description"),
    gxpReady: yup
      .object({
        shouldBePublished: yup
          .boolean()
          .required(),
        newValue: yup
          .object({
            key: yup
              .string(),
            value: yup
              .string()
          })
          .required(`Enter ${ DATA_MODEL_TABLE?.gxpReady?.value }`)
      }),
    systemStatus: yup
      .object({
        shouldBePublished: yup
          .boolean()
          .required(),
        newValue: yup
          .object({
            key: yup
              .string()
            .required(`Enter ${ DATA_MODEL_TABLE?.systemStatus?.key }`),
            value: yup
              .string(),
          })
          .required(`Enter ${ DATA_MODEL_TABLE?.systemStatus?.value }`)
      }),
    updatedSoftwareVersion: yup
      .object()
      .when(
        "action",
        {
          is: ACTION_LOG_ACTION_TYPE.SOFTWARE_CHANGE,
          then: yup.object({
            shouldBePublished: yup
              .boolean()
              .required(),
            newValue: yup
              .string()
          }),
        }),
    logbookConfigurationDetails: yup
      .object({
        shouldBePublished: yup
          .boolean()
          .required(),
        newValue: yup
          .string()
      })
  });
